import {
  COMPLAIN_LIST_FAILED,
  COMPLAIN_LIST_LOADDATA,
  COMPLAIN_LIST_LOADING,
  COMPLAIN_LIST_SUCCESS,
} from '../constants/ComplainlistConst';

export const success = (data) => {
  return {
    type: COMPLAIN_LIST_SUCCESS,
    data,
  };
};

export const failed = () => {
  return {
    type: COMPLAIN_LIST_FAILED,
  };
};

export const loading = () => {
  return {
    type: COMPLAIN_LIST_LOADING,
  };
};

export const loaddata = ({ page: page, filter: filter }) => {
  return {
    type: COMPLAIN_LIST_LOADDATA,
    page,
    filter,
  };
};
